import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "column-space fix-td"
}
const _hoisted_2 = { class: "column-space" }
const _hoisted_3 = { class: "column-space" }
const _hoisted_4 = { class: "column-space" }
const _hoisted_5 = { class: "column-space" }
const _hoisted_6 = { class: "column-space" }
const _hoisted_7 = { class: "column-space" }
const _hoisted_8 = { class: "column-space" }
const _hoisted_9 = { class: "column-space" }
const _hoisted_10 = { class: "column-space" }
const _hoisted_11 = { class: "column-space" }
const _hoisted_12 = { class: "column-space" }
const _hoisted_13 = { class: "column-space" }
const _hoisted_14 = { class: "d-flex" }

import Api from "@/services/api/ApiServiceFabrick";
import StatusChangeConfirmModal from "@/components/AccountParts/StatusChangeConfirmModal.vue";
import DeleteIcon from "@/components/Common/DeleteIcon.vue"
import EditLinkIcon from "@/components/Common/EditLinkIcon.vue";
import DisplayFullnameFromUpdatedBy from '@/components/Common/DisplayFullnameFromUpdatedBy.vue';
import { formatDateTime } from "@/services/functions"
import AccountWithUpdater from "@/types/AccountWithUpdater";
import i18n from '@/lang/i18n';
import { useRouter } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'AccountListRow',
  props: {
    isAdmin: { type: Boolean },
    account: {},
    changeStatusAuthority: { type: Boolean },
    listLoading: { type: Boolean },
    updatingStatus: { type: Boolean },
    deletable: { type: Boolean },
    showFlash: { type: Function },
    reload: { type: Function },
    isOperationOffice: { type: Boolean }
  },
  emits: ['changeStatus'],
  setup(__props: any, { emit: __emit }) {

const router = useRouter()

const props = __props;
const emits = __emit;

const officeableTypeNames: {[key:string]: string} = {
  ManagementOffice: i18n.global.t('pages.accounts.managementOffice'),
  SubManagementOffice: i18n.global.t('pages.accounts.subManagementOffice'),
  OperationOffice: i18n.global.t('pages.accounts.operationOffice'),
  InstallationOffice: i18n.global.t('pages.accounts.installationOffice')
}

const roles = {
  1: i18n.global.t('pages.accounts.administrator'),
  2: i18n.global.t('pages.accounts.driver')
};

function officeableTypeName(officeableType: string) {
  const type = officeableType.split('\\')[2];
  return officeableTypeNames[type];
}
function officeableName() {
  const type = props.account.officeable_type.split('\\')[2];
  if (type == 'OperationOffice') {
    return props.account.officeable.operation_office_name;
  }
  return props.account.officeable.company_name;
}

function emitChangeStatus(params: any) {
  emits('changeStatus', params);
}

async function deleteAction() {
  await Api().deleteAccount(props.account).then(() => {
    props.showFlash(i18n.global.t('pages.common.messages.successDelete'), "success", true)
    props.reload();
  }).catch((e) => {
    errorHandleForDelete(e?.response);
  })
}

function errorHandleForDelete (res: any) {
  switch (res.status) {
    case 400:
      props.showFlash(i18n.global.t('pages.accounts.messages.badRequestForDelete'), "error", true)
      props.reload();
      break
    case 403:
      props.showFlash(i18n.global.t('pages.common.messages.forbidden'), "error", true)
      props.reload();
      break
    default:{
      props.showFlash(i18n.global.t('pages.common.messages.failedDelete'), "error", true)
      props.reload();
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    (!props.isOperationOffice)
      ? (_openBlock(), _createElementBlock("td", _hoisted_1, _toDisplayString(__props.account.id), 1))
      : _createCommentVNode("", true),
    _createElementVNode("td", _hoisted_2, _toDisplayString(__props.account.last_name + ' ' + __props.account.first_name), 1),
    _createElementVNode("td", _hoisted_3, _toDisplayString(__props.account.no_email ? '' : __props.account.email), 1),
    _createElementVNode("td", _hoisted_4, _toDisplayString(officeableTypeName(__props.account.officeable_type)), 1),
    _createElementVNode("td", _hoisted_5, _toDisplayString(officeableName(__props.account)), 1),
    _createElementVNode("td", _hoisted_6, _toDisplayString(__props.account.department?.name), 1),
    _createElementVNode("td", _hoisted_7, _toDisplayString(roles[__props.account.role_id]), 1),
    _createElementVNode("td", _hoisted_8, _toDisplayString(__props.account.driver_id), 1),
    _createElementVNode("td", _hoisted_9, _toDisplayString(__props.account.telephone_number), 1),
    _createElementVNode("td", _hoisted_10, [
      _createVNode(StatusChangeConfirmModal, {
        item: __props.account,
        updatableStatusButton: __props.changeStatusAuthority,
        updatingStatus: __props.updatingStatus,
        onSubmit: emitChangeStatus
      }, null, 8, ["item", "updatableStatusButton", "updatingStatus"])
    ]),
    _createElementVNode("td", _hoisted_11, _toDisplayString(_unref(formatDateTime)(new Date(__props.account.updated_at))), 1),
    _createElementVNode("td", _hoisted_12, [
      _createVNode(DisplayFullnameFromUpdatedBy, {
        updatedBy: __props.account.updated_by
      }, null, 8, ["updatedBy"])
    ]),
    _withDirectives(_createElementVNode("td", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(EditLinkIcon, {
          name: 'AccountForm',
          id: __props.account.id
        }, null, 8, ["id"]),
        (props.deletable)
          ? (_openBlock(), _createBlock(DeleteIcon, {
              key: 0,
              deleteAction: deleteAction,
              isDeleteAuthority: props.deletable
            }, null, 8, ["isDeleteAuthority"]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, props.isAdmin]
    ])
  ]))
}
}

})